module.exports = {
  Tab: require('./lib/Tab'),
  TabList: require('./lib/TabList'),
  TabPanel: require('./lib/TabPanel'),
  Wrapper: require('./lib/Wrapper'),
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-aria-tabpanel/index.js
// module id = 595
// module chunks = 0